module.exports = __webpack_public_path__ + "static/media/champion.7357c0a6.mp3";